import { gsap } from "gsap";

export default class PointsDeVente {
  constructor() {
    console.log(":: PointsDeVente ::");

    // Elements
    this.sectionPdv = document.querySelector(".section-pdv");
    this.sectionPdvResultsCount = this.sectionPdv.querySelector(
      ".section-pdv__results__head strong"
    );
    this.sectionPdvResults = this.sectionPdv.querySelector(
      ".section-pdv__results__list"
    );
    this.sectionPdvMap = this.sectionPdv.querySelector(".section-pdv__map");
    this.sectionPdvInput = this.sectionPdv.querySelector(
      "form input[type='text']"
    );
    this.sectionPdvSubmit = this.sectionPdv.querySelectorAll(
      ".section-pdv__searchbox__top__submit, .section-pdv__searchbox__find"
    );
    this.sectionPdvGeolocate = this.sectionPdv.querySelector(
      ".section-pdv__searchbox__top__geolocate"
    );
    this.sectionPdvRefresh = this.sectionPdv.querySelector(
      ".section-pdv__searchbox__refresh"
    );
    this.sectionPdvTop = this.sectionPdv.querySelector(
      ".section-pdv__searchbox__top"
    );
    this.sectionPdvTicketOffice = this.sectionPdv.querySelector(
      ".section-pdv__searchbox__middle__filter"
    );

    // Vars
    this.isFirstLoad = true;
    this.isGeolocated = false;
    this.geoLatitude = null;
    this.latitude = 45.5019;
    this.geoLongitude = null;
    this.longitude = -73.5674;
    this.isTicketOffice = false;
    this.disable = true;

    // Bindings
    this.sectionPdvSubmitClick = this.sectionPdvSubmitClick.bind(this);
    this.searchByGeolocation = this.searchByGeolocation.bind(this);
    this.refreshSearch = this.refreshSearch.bind(this);
    this.cookiebotOnAccept = this.cookiebotOnAccept.bind(this);
    this.filterByTicketOffice = this.filterByTicketOffice.bind(this);

    // Listeners
    for (let i = 0; i < this.sectionPdvSubmit.length; i++) {
      this.sectionPdvSubmit[i].addEventListener(
        "click",
        this.sectionPdvSubmitClick
      );
    }
    this.sectionPdvGeolocate.addEventListener(
      "click",
      this.searchByGeolocation
    );

    this.sectionPdvTicketOffice.addEventListener(
      "click",
      this.filterByTicketOffice
    );

    this.sectionPdvRefresh.addEventListener("click", this.refreshSearch);

    // Methods
    gsap.delayedCall(0.2, () => {
      this.initGeolocalisation();
      if (
        window.Cookiebot &&
        window.Cookiebot.consent &&
        window.Cookiebot.consent.marketing
      ) {
        this.initMap();
      } else {
        this.initMapConsent();
        window.addEventListener("CookiebotOnAccept", this.cookiebotOnAccept);
      }
    });
  }

  initGeolocalisation() {
    // Display loader
    this.sectionPdv.classList.add("section-pdv--loading");

    if ("geolocation" in navigator) {
      // Geolocation is available
      navigator.geolocation.getCurrentPosition(
        (position) => {
          // Success callback - user allowed geolocation
          this.isGeolocated = true;
          this.isFirstLoad = true;
          this.sectionPdv.classList.add("section-pdv--geolocated");
          this.geoLatitude = position.coords.latitude;
          this.geoLongitude = position.coords.longitude;
          this.latitude = this.geoLatitude;
          this.longitude = this.geoLongitude;
          // this.makeAjaxCall(-1);

          console.log(
            "Latitude: " +
              position.coords.latitude +
              ", Longitude: " +
              position.coords.longitude
          );
        },
        (error) => {
          // Error callback - user denied geolocation or there was an error
          this.isGeolocated = false;
          // this.setMapToDefault();

          this.sectionPdv.classList.remove("section-pdv--geolocated");

          switch (error.code) {
            case error.PERMISSION_DENIED:
              console.error("User denied the request for Geolocation.");
              this.showSettingsMessage();
              break;
            case error.POSITION_UNAVAILABLE:
              console.error("Location information is unavailable.");
              break;
            case error.TIMEOUT:
              console.error("The request to get user location timed out.");
              break;
            case error.UNKNOWN_ERROR:
              console.error("An unknown error occurred.");
              break;
          }
        }
      );

      if (!this.isGeolocated) {
        this.isGeolocated = false;
        this.setMapToDefault();
      } else {
        this.makeAjaxCall(-1);
      }
    } else {
      // Geolocation is not supported
      this.isGeolocated = false;
      this.setMapToDefault();
      this.sectionPdv.classList.remove("section-pdv--geolocated");
      console.error("Geolocation is not supported by this browser.");
    }
  }

  makeAjaxCall(limit = 10) {
    // Display loader
    this.sectionPdv.classList.add("section-pdv--loading");

    // Create a new XMLHttpRequest object
    const xhr = new XMLHttpRequest();

    // Endpoint URL
    let url = `//${window.location.hostname}/wp-admin/admin-ajax.php?action=get_point_de_vente&latitude=${this.latitude}&longitude=${this.longitude}&limit=${limit}`;

    if (this.isTicketOffice) {
      url += "&type=Billetterie%20m%C3%A9tropolitaine";
    }

    if (document.documentElement.lang == "fr-FR") {
      url += "&lang=fr";
    } else {
      url += "&lang=en";
    }

    // Map marker
    const customMarkerImage = `//${window.location.hostname}/wp-content/themes/adviztheme-child/assets/img/map-pin-teal.png`;
    const customMarkerImageActive = `//${window.location.hostname}/wp-content/themes/adviztheme-child/assets/img/map-pin-blue.png`;

    // Open a GET request
    xhr.open("GET", url, true);

    // Set up onload and onerror handlers
    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        // Successful request, handle the response
        const response = JSON.parse(xhr.responseText);
        // console.log("Response:", response);

        // Clear previous markers & show results
        this.locations = [];
        if (this.markers && this.markers.length) {
          this.markers.forEach((marker) => {
            marker.setMap(null);
          });
        }
        this.markers = [];
        this.lastActiveMarker = null;
        this.sectionPdvResultsCount.innerHTML = response.length;
        this.sectionPdvResults.innerHTML = "";
        let htmlContent = "";
        const labelItinerary =
          document.documentElement.lang == "fr-FR" ? "Itinéraire" : "Itinerary";
        const labelTo = document.documentElement.lang == "fr-FR" ? "à" : "to";
        const labelClosed =
          document.documentElement.lang == "fr-FR" ? "fermé" : "closed";
        const labelAllDay =
          document.documentElement.lang == "fr-FR"
            ? "Toute la journée"
            : "All day";
        const labelOpeningHours =
          document.documentElement.lang == "fr-FR"
            ? "Horaire d’ouverture"
            : "Opening hours";
        const days =
          document.documentElement.lang == "fr-FR"
            ? [
                "lundi",
                "mardi",
                "mercredi",
                "jeudi",
                "vendredi",
                "samedi",
                "dimanche",
              ]
            : [
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday",
                "Sunday",
              ];

        response.forEach((entry, index) => {
          this.locations.push({
            lat: parseFloat(entry.latitude),
            lng: parseFloat(entry.longitude),
          });

          let entryDom = `
            <div class="block-result" data-id="${index}">
              <div class="block-result__infos">
                  <h3>${entry.nom}</h3>
                  <div class="block-result__infos__address">
                    <p>${entry.noCivique} ${entry.nomRue}, ${
            entry.municipalite
          }, ${entry.province}, ${entry.codePostal}</p>

                ${
                  entry.type == "Billetterie métropolitaine"
                    ? `<div ><p class="block-result__infos__address__tag">${entry.type_translated}</p></div>`
                    : ""
                }

                    </div>
                  ${
                    entry.telephone
                      ? '<a href="tel:' +
                        entry.telephone +
                        '" target="_top" class="block-result__infos__phone" data-tracking="cta">' +
                        entry.telephone +
                        "</a>"
                      : ""
                  }
                  <a href="https://www.google.com/maps/dir//${entry.nom.replace(
                    / /g,
                    "+"
                  )}+${entry.noCivique}+${entry.nomRue}+${
            entry.municipalite
          }" class="block-result__infos__itinerary" target="_blank" data-tracking="cta">${labelItinerary}</a>
              </div>
              `;
          if (entry.horaires.length) {
            entryDom += `
                <div class="block-result__hours">
                  <strong>${labelOpeningHours}</strong>`;
            for (let i = 0; i < entry.horaires.length; i++) {
              let hourStart =
                document.documentElement.lang == "fr-FR"
                  ? entry.horaires[i].heureDebut
                  : this.convertTo12HourFormat(entry.horaires[i].heureDebut);
              let hourEnd =
                document.documentElement.lang == "fr-FR"
                  ? entry.horaires[i].heureFin
                  : this.convertTo12HourFormat(entry.horaires[i].heureFin);
              let openingHour = hourStart + " " + labelTo + " " + hourEnd;

              if (
                entry.horaires[i].heureDebut == "00h00" &&
                entry.horaires[i].heureFin == "24h00"
              ) {
                openingHour = labelAllDay;
              }

              entryDom += `<div class="block-result__hours__single">
                  <span>${days[entry.horaires[i].jour]}</span>
                  <span>${
                    entry.horaires[i].estFermeJournee == "1"
                      ? labelClosed
                      : openingHour
                  }</span>
              </div>`;
            }
            entryDom += `</div>`;
          }
          entryDom += `</div>`;
          htmlContent += entryDom;
        });
        this.sectionPdvResults.innerHTML += htmlContent;

        if (this.map) {
          // Create markers for each location
          this.locations.forEach((location) => {
            const marker = new google.maps.Marker({
              position: location,
              map: this.map,
              icon: customMarkerImage,
            });
            this.markers.push(marker);
          });

          // Adjust the map's center and zoom level to fit all markers
          if (!this.isFirstLoad) {
            var bounds = new google.maps.LatLngBounds();
            this.locations.forEach((location) => {
              bounds.extend(location);
            });
            this.map.fitBounds(bounds);
          }
          this.isFirstLoad = false;

          // Markers listeners
          this.markers.forEach((marker, index) => {
            marker.addListener("click", (e) => {
              const selected = this.sectionPdvResults.querySelector(
                ".block-result--selected"
              );
              if (selected) selected.classList.remove("block-result--selected");
              const blockResult = this.sectionPdvResults.querySelector(
                `[data-id="${index}"]`
              );
              blockResult.classList.add("block-result--selected");

              // Edit custom icon
              if (this.lastActiveMarker) {
                this.markers[this.lastActiveMarker].setIcon({
                  url: customMarkerImage,
                });
              }
              marker.setIcon({ url: customMarkerImageActive });
              this.lastActiveMarker = index;

              // Calculate the distance between the top of the scrollable div and the element
              const distance =
                blockResult.offsetTop - this.sectionPdvResults.offsetTop;

              // Scroll the div to the selected element by setting its scrollTop property
              this.sectionPdvResults.scrollTop = distance;

              // scrollIntoView test
              this.sectionPdvResults.scrollIntoView({
                behavior: "smooth",
                block: "end",
              });
            });
          });
        }

        // Display results & map infos
        this.sectionPdv.classList.add("section-pdv--results");

        // Hide loader
        this.sectionPdv.classList.remove("section-pdv--loading");

        // Scroll to top inside list
        this.sectionPdvResults.scrollTop = 0;

        // Add tracking logic
        this.ctas = this.sectionPdvResults.querySelectorAll(
          '[data-tracking="cta"]'
        );
        for (let i = 0; i < this.ctas.length; i++) {
          this.ctas[i].addEventListener("click", this.trackingCtaClick);
        }
      } else {
        // Request error
        console.error("Request failed with status:", xhr.status);
      }
    };

    xhr.onerror = () => {
      // Network errors
      console.error("Request failed");
    };

    // Send the request
    xhr.send();
  }

  initMap() {
    if (!this.map) {
      this.map = new google.maps.Map(this.sectionPdvMap, {
        center: { lat: this.latitude, lng: this.longitude }, // Center map at (0,0) initially
        zoom: 11, // Set initial zoom level
        disableDefaultUI: true, // Disable default UI
        zoomControl: true, // Disable zoom control
        streetViewControl: false, // Disable street view control
        styles: [
          {
            featureType: "all",
            elementType: "all",
            stylers: [
              { saturation: -100 }, // Make the map black and white
              { lightness: 10 }, // Adjust the lightness for better contrast (you can tweak this value)
            ],
          },
        ],
      });
    }
  }

  cookiebotOnAccept() {
    if (window.Cookiebot.consent.marketing) {
      if (!this.map) {
        this.initMap();
        gsap.delayedCall(0.2, () => {
          if (this.isGeolocated) {
            this.latitude = this.geoLatitude;
            this.longitude = this.geoLongitude;
            this.isFirstLoad = true;
            this.makeAjaxCall();
          } else {
            this.latitude = this.latitude;
            this.longitude = this.longitude;
            this.isFirstLoad = true;
            this.makeAjaxCall(-1);
          }
        });
      }
    }
  }

  sectionPdvSubmitClick(e) {
      e.preventDefault();

      const addressToGeocode = this.sectionPdvInput.value.trim();

      if (addressToGeocode !== "") {

        // Load the Google Maps JavaScript API
        if (typeof google !== 'undefined' && google.maps && google.maps.Geocoder) {

          const geocoder = new google.maps.Geocoder();

          geocoder.geocode({ 'address': addressToGeocode }, (results, status) => {
            if (status === 'OK') {
              if (results[0]) {
                const location = results[0].geometry.location;
                this.latitude = location.lat();
                this.longitude = location.lng();

                // Geocoding OK, make ajax call to get results
                this.makeAjaxCall();
              } else {
                  console.log("Geocoding error: No results found");
              }
            } else {
                console.log("Geocoding error: " + status);
            }
          });

        } else {
          console.error("Can't load Google Maps API");
          // Handle the case where the API isn't ready (maybe show a message)
        }

      // Tracking
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "recherche_localisateur",
        click_text: this.sectionPdvInput.value.trim(),
      });
    } else if (this.isTicketOffice) {
      this.makeAjaxCall(-1);
    } else if (this.sectionPdvInput.value.trim() == "") {
      this.sectionPdvInput.focus();
    }
  }

  showSettingsMessage() {
    // Create a message that instructs the user to enable geolocation in browser settings
    const message = document.createElement("p");
    message.textContent =
      document.documentElement.lang == "fr-FR"
        ? "La géolocalisation est désactivée. Veuillez l'activer dans les paramètres de votre navigateur."
        : "Geolocation is disabled. Please enable it in your browser settings.";
    this.sectionPdvTop.parentNode.insertBefore(
      message,
      this.sectionPdvTop.nextSibling
    );
  }

  initMapConsent() {
    const consentDiv = document.createElement("div");
    consentDiv.classList.add("cookieconsent-optout-marketing");
    const consentLink = document.createElement("a");
    consentLink.href = "javascript:Cookiebot.renew()";
    consentLink.textContent = "accept marketing-cookies";
    consentDiv.appendChild(document.createTextNode("Please "));
    consentDiv.appendChild(consentLink);
    consentDiv.appendChild(document.createTextNode(" to view the map."));
    this.sectionPdvMap.appendChild(consentDiv);

    consentLink.addEventListener("click", function (e) {
      e.preventDefault();
      window.Cookiebot.renew();
    });

    if (document.documentElement.lang === "fr-FR") {
      consentDiv.innerHTML =
        "Veuillez <a href='javascript:Cookiebot.renew()'>accepter les cookies marketing</a> pour afficher la carte.";
    }
  }

  searchByGeolocation(e) {
    e.preventDefault();

    this.sectionPdvInput.value = "";
    this.latitude = this.geoLatitude ? this.geoLatitude : this.latitude;
    this.longitude = this.geoLongitude ? this.geoLongitude : this.longitude;
    this.isFirstLoad = false;
    this.makeAjaxCall();

    // Tracking
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "recherche_localisateur",
      click_text: e.target.innerText.trim(),
    });
  }

  filterByTicketOffice(e) {
    e.preventDefault();
    this.sectionPdvTicketOffice.classList.toggle("active");

    if (this.sectionPdvTicketOffice.classList.contains("active")) {
      this.isTicketOffice = true;
    } else {
      this.isTicketOffice = false;
    }
  }

  refreshSearch(e) {
    e.preventDefault();
    this.sectionPdvInput.value = "";
    // this.latitude = this.geoLatitude ? this.geoLatitude : this.latitude;
    // this.longitude = this.geoLongitude ? this.geoLongitude : this.longitude;
    this.isTicketOffice = false;
    this.sectionPdvTicketOffice.classList.remove("active");

    this.setMapToDefault();

    // Tracking
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "recherche_localisateur",
      click_text: e.target.innerText.trim(),
    });
  }

  setMapToDefault() {
    this.latitude = 45.5019; // reset to montreal
    this.longitude = -73.5674; // reset to montreal
    if (this.map) {
      this.map.setCenter({ lat: this.latitude, lng: this.longitude });
      this.map.setZoom(11);
    }
    this.isFirstLoad = true;
    this.makeAjaxCall(-1);
  }

  convertTo12HourFormat(time) {
    const [hourString, minuteString] = time.split("h");
    const hour = parseInt(hourString, 10);
    const minute = parseInt(minuteString, 10);

    let period = "am";
    let convertedHour = hour;

    if (hour >= 12) {
      period = "pm";
      if (hour > 12) {
        convertedHour = hour - 12;
      }
    }

    if (convertedHour === 0) {
      convertedHour = 12;
    }

    let formattedTime;

    if (minute === 0) {
      formattedTime = `${convertedHour}${period}`;
    } else {
      formattedTime = `${convertedHour}:${minute
        .toString()
        .padStart(2, "0")}${period}`;
    }

    return formattedTime;
  }

  trackingCtaClick(e) {
    // Tracking
    window.dataLayer.push({
      event: "cta",
      click_url: e.target.href,
      click_text: e.target.innerText.trim(),
      internal: e.target.target == "_blank" ? false : true,
      cta_type: "localisateur point de vente",
    });
  }
}
